export class StatutDA {
    codeAia: string;
    codeAde: string;
    typeDashboard: string;

    constructor(codeAia: string, codeAde: string, typeDashboard: string) {
        this.codeAia = codeAia;
        this.codeAde = codeAde;
        this.typeDashboard = typeDashboard;
    }
}
